$(document).ready(function(){
//home page small image slider
$(document).on("mouseover",".itg_card_tab P", function(){
      $(".itg_card_tab P").removeClass('active');
      $(this).addClass('active');
      var value_1 = $(this).attr("DataTab");     
     $(".tab_image").each(function(){
      var value_2 = $(this).attr("DataContent");
       if(value_1 == value_2){
         $(this).addClass("image-active")
       }
       else{
         $(this).removeClass("image-active")
       }
     })
   });
//Announcement bar slider 
  // $('.itg_announcement_bar_slider').slick({
  //   slidesToScroll: 1,
  //   arrows: false,
  //   autoplay:true,
  //   autoplaySpeed:1500,
  //   dots: false,
  //   vertical: true,
  //   verticalSwiping: true
  // });
  var mySwiper = new Swiper ('.itg_announcement_bar_slider', {
    direction: 'vertical',
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
});
   //Featured Collection slider
//   $('.itg_featured_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 3.5,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//        {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });


  // IMAGE WITH SLIDER
  var swiper = new Swiper(".custom_image_width_slider_head ", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });

  // CUSTOM MULTICOLUMN
  // var swiper = new Swiper(".custom_multicolumn_head", {
  //   slidesPerView: 3,
  //   spaceBetween: 30,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //       768: {
  //         slidesPerView: 1,         
  //       }
  //     },
  // });

    var swiper = new Swiper(".custom_multicolumn_head", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },    
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3,          
        },
        768: {
          slidesPerView: 2,         
        },
         0: {
          slidesPerView: 1,
        }
      },
    });

  var swiper = new Swiper(".custom_image_with_text_image", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });
  
  var swiper = new Swiper(".itg_featured_collection_slider", {
      spaceBetween: 0,
      loop: false,
      //freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next.itg-swiper-arrow',
        prevEl: '.swiper-button-prev.itg-swiper-arrow'
      },      
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3.5,          
        },
        768: {
          slidesPerView: 2,         
        },
         480: {
          slidesPerView: 1,
        }
      },
    });
  //collection list section slider
//   $('.itg_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 4.1,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });
var window_width = $(window).width();

  var $swiperSelector = $('.itg_collection_slider.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : true;
    var loop = $this.data('loop') ? $this.data('loop') : false; 

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      allowTouchMove: true,
      freeMode: freeMode,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: 5,
        },
        768:{
          slidesPerView: 3,
          allowTouchMove: true,
        },
        480: {
           slidesPerView: 1.2,
           allowTouchMove: true,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      }
   });
});


//loyalty program slider
var swiper = new Swiper(".itg_loy_slider", {
  //effect: "fade",
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
});

//Custom banner slider 
var swiper = new Swiper(".itg_banner_slider", {
  //effect: "fade",
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});  
  

  $('.itg_megamenu').click(function(){
    $(this).closest('.site-nav__details').removeAttr('open');
  });


if (window.matchMedia("(max-width: 768px)").matches) {
  var swiper = new Swiper(".itg_collection_list", {
      spaceBetween: 10,
      loop: false,
      slidesPerView: 2,
      //freeMode: true,    
      scrollbar: {
        el: '.swiper-scrollbar1',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        768: {
          slidesPerView: 2        
        }
      }
    });
}


//add class on scroll
$(window).scroll(function() {
  if ($(this).scrollTop() > 200){
    $('.announcement-bar').addClass("itg_fixed");
  } else {
    $('.announcement-bar').removeClass("itg_fixed");
  }
});
});

// $(document).load($(window).bind("resize", checkPosition));
// function checkPosition(){
//    if($(window).width() >= 767){
//      var swiper = new Swiper(".itg_collection_list", {
//       spaceBetween: 0,
//       loop: false,
//       //freeMode: true,    
//       scrollbar: {
//         el: '.swiper-scrollbar1',
//         draggable: true,
//         dragSize: 100
//       },
//       breakpoints: {
//         768: {
//           slidesPerView: 2,         
//         },
//          480: {
//           slidesPerView: 1,
//         }
//       },
//     });
//    }
// }


//Show sahre data on product page 
$(document).on('click', '.itg_share_icon', function(){
  $('.itg_show_share_icon').toggleClass('open')
});

//Faq page search option
 $(document).on('change keyup paste', '.faqAccordianBanner_search input#search', function(){
    // console.log('key');
    var searchtermNF = $(this).val();
    var searchTerm = $(this).val().toUpperCase();
    // console.log(searchTerm);
    if ( searchTerm == "" ) {
      $('.faqAccordianError_message').hide();
      $('.itg_faq_accordion.itg_faq_heading').show();
      $('.itg_fqa_question').show();
      return;
    }
    $(".itg_fqa_question").each(function(){
      var accordianText = $(this).find('.itg_faq_data button.collapsible-trigger span.itg_accordion_title').text().toUpperCase();
      // console.log('accordian Text----' + accordianText)
      if  ( accordianText.indexOf(searchTerm) != -1) {
        $(this).show();
        $(this).addClass('searchMatched');
        $('.itg_faq_accordion.itg_faq_heading').hide();
        $('.itg_faq_accordion.itg_faq_heading:first').show();
      }else{
        $(this).hide();
        $(this).removeClass('searchMatched');
      }

      var MatchedLength = $('.itg_fqa_question.searchMatched').length;
      // console.log(MatchedLength)
      if(MatchedLength >= 1) {
        $('.faqAccordianError_message').hide();
      }else{
        $('.faqAccordianError_message span').text(searchtermNF);
        $('.faqAccordianError_message').show();
        $('.itg_faq_accordion.itg_faq_heading').hide();
      }
    });
  });






//custom cursor
// const cursor = document.querySelector('.cursor');

// document.addEventListener('mousemove', e => {
//     cursor.setAttribute("style", "top: " + (e.pageY - 10) + "px; left: " + (e.pageX - 10) + "px;")
// });

// document.addEventListener('click', e => {
//     cursor.classList.add("expand");
//     setTimeout(() => {
//         cursor.classList.remove("expand");
//     }, 500);
// });

let clientX = -100;
let clientY = -100;
const innerCursor = document.querySelector(".cursor--small");

const initCursor = () => {

  document.addEventListener("mousemove", e => {
    clientX = e.clientX;
    clientY = e.clientY;
  });
  
  
  // const render = () => {
  //   innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
    
  //   requestAnimationFrame(render);
  // };
  // requestAnimationFrame(render);
};

initCursor();
let lastX = 0;
let lastY = 0;
let isStuck = false;
let showCursor = false;
let group, stuckX, stuckY, fillOuterCursor;

const initCanvas = () => {
  const canvas = document.querySelector(".cursor--canvas");
  const shapeBounds = {
    width: 75,
    height: 75
  };
  paper.setup(canvas);
  const strokeColor = "rgba(0, 0, 0, 0.5)";
  const strokeWidth = 1;
  const segments = 8;
  //const radius = 25;
  const radius = 12;
  
  const noiseScale = 150; // speed
  const noiseRange = 4; // range of distortion
  let isNoisy = false; // state
  
  const polygon = new paper.Path.RegularPolygon(
    new paper.Point(0, 0),
    segments,
    radius
  );
  polygon.strokeColor = strokeColor;
  polygon.strokeWidth = strokeWidth;
  polygon.smooth();
  group = new paper.Group([polygon]);
  group.applyMatrix = false;
  
  const noiseObjects = polygon.segments.map(() => new SimplexNoise());
  let bigCoordinates = [];
  
  
  const lerp = (a, b, n) => {
    return (1 - n) * a + n * b;
  };
  const map = (value, in_min, in_max, out_min, out_max) => {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  };
  
  paper.view.onFrame = event => {
   
    lastX = lerp(lastX, clientX, 0.2);
    lastY = lerp(lastY, clientY, 0.2);
    group.position = new paper.Point(lastX, lastY);
  }
}

// initCanvas();
const initHovers = () => {

  const handleMouseEnter = e => {
    const navItem = e.currentTarget;
    const navItemBox = navItem.getBoundingClientRect();
    stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
    stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
    isStuck = true;
  };
  
  const handleMouseLeave = () => {
    isStuck = false;
  };
  
  //Event listeners
  const linkItems = document.querySelectorAll(".link");
  linkItems.forEach(item => {
    item.addEventListener("mouseenter", handleMouseEnter);
    item.addEventListener("mouseleave", handleMouseLeave);
  });
};

initHovers();

//Find your size page 
  var opt1 = document.getElementById('option-1');
  var opt2 = document.getElementById('option-2');
  var dtImage = document.getElementById('dt-image')
  var mbImage = document.getElementById('mb-image')

  function toggleIn() {
    console.log(opt1.dataset.toggle);
    opt1.style.fontWeight = "600";
    opt2.style.fontWeight = "400";

    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset = "https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-desktop.png?v=1663865318";
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-mobile.png?v=1663865332';

    }

  }


  function toggleCm() {
    opt2.style.fontWeight = "600";
    opt1.style.fontWeight = "400";
    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset =
        'https://cdn.shopify.com/s/files/1/1365/7915/files/desktop-cm_9e9069a9-60b8-4614-aecd-b860d9ce04cc.png?v=1663875210';
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/mobile_cm.png?v=1663873928';

    }

  }

// function searchDrawer() {
//   let searchIcon = document.querySelector(".search-mobile-filter");
//   let searchIcondesktop = document.querySelector(".desktop-search");
//   let mobileSearchdrawer = document.querySelector('.mobile-drawer-search');
//   let closeMobilesearch = document.querySelector('.close-wrapper-icon');
//   let bodyElement = document.body;
//   if (searchIcon && mobileSearchdrawer && bodyElement) {
//     searchIcon.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
//   if(closeMobilesearch && mobileSearchdrawer && bodyElement){
//     closeMobilesearch.addEventListener("click", function () {
//       mobileSearchdrawer.classList.remove('active-drawer');
//       bodyElement.classList.remove('overflow-hidden');
//     });
//   }
//   if (searchIcondesktop && mobileSearchdrawer && bodyElement) {
//     searchIcondesktop.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
// }
function searchDrawer() {
  let searchIcon = document.querySelector(".search-mobile-filter");
  let searchIconsDesktop = document.querySelectorAll(".desktop-search"); // multiple desktop icons
  let mobileSearchdrawer = document.querySelector('.mobile-drawer-search');
  let closeMobilesearch = document.querySelector('.close-wrapper-icon');
  let bodyElement = document.body;

  // Mobile search icon click
  if (searchIcon && mobileSearchdrawer && bodyElement) {
    searchIcon.addEventListener("click", function () {
      mobileSearchdrawer.classList.add('active-drawer');
      bodyElement.classList.add('overflow-hidden');
    });
  }

  // Close search drawer
  if (closeMobilesearch && mobileSearchdrawer && bodyElement) {
    closeMobilesearch.addEventListener("click", function () {
      mobileSearchdrawer.classList.remove('active-drawer');
      bodyElement.classList.remove('overflow-hidden');
    });
  }

  // Desktop search icons click (loop for all)
  if (searchIconsDesktop.length && mobileSearchdrawer && bodyElement) {
    searchIconsDesktop.forEach(function (icon) {
      icon.addEventListener("click", function () {
        mobileSearchdrawer.classList.add('active-drawer');
        bodyElement.classList.add('overflow-hidden');
      });
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  searchDrawer();
});

function my_code(){
  var a = document.querySelector('a[href="https://www.naniswimwear.com/products/coastal-hybrid-explorer-short?_pos=1&_psq=coastal-h&_ss=e&_v=1.0"]');
  if (a) {
    a.setAttribute('href', '/')
  }
}

window.addEventListener('load', function() {
  setTimeout(my_code, 1000);
});


      document.addEventListener("DOMContentLoaded", function () {
        const swimwearHeaders = document.querySelectorAll('.SiteHeaderMain');
        const lifestyleHeaders = document.querySelectorAll('.ctm-header');
        const tabs = document.querySelectorAll('.tab-btn');
        const announcementBar = document.querySelector('.announcement-bar');

        function showHeader(type) {
          if (type === "swimwear") {
            lifestyleHeaders.forEach(el => el.style.display = 'none');
            swimwearHeaders.forEach(el => el.style.display = '');
          } else if (type === "lifestyle") {
            swimwearHeaders.forEach(el => el.style.display = 'none');
            lifestyleHeaders.forEach(el => el.style.display = '');
          }

          // Update active tab visually
          tabs.forEach(tab => {
            if (tab.dataset.header === type) {
              tab.classList.add("is-active");
            } else {
              tab.classList.remove("is-active");
            }
          });

          // 🟡 Add class to announcement bar if lifestyle
          if (announcementBar) {
            if (type === "lifestyle") {
              announcementBar.classList.add("lifestyle-mode");
            } else {
              announcementBar.classList.remove("lifestyle-mode");
            }
          }
        }

        // Home page check
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
        const savedHeader = isHomePage ? "swimwear" : (localStorage.getItem("activeHeader") || "swimwear");

        // Header show only once during page load
        showHeader(savedHeader);

        // Tab click: only update localStorage and active class
        tabs.forEach(tab => {
          tab.addEventListener("click", function () {
            const selected = this.dataset.header;

            // Save selection but do not run showHeader()
            localStorage.setItem("activeHeader", selected);

            // Update active tab only
            tabs.forEach(t => t.classList.remove("is-active"));
            this.classList.add("is-active");

            // Do NOT call showHeader() here
          });
        });
      });


document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.desktop-search');
  if (!trigger) return;

  var activated = false;

  trigger.addEventListener('click', function () {
    if (activated) return;
    activated = true;

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      // Fade-in once image is loaded
      img.addEventListener('load', function onLoad() {
        img.classList.add('loaded');
        img.removeEventListener('load', onLoad);
      });

      // Restore responsive attributes
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }

      // Restore src
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  });
});



  (function ($) {
    if (!$) return;

    var TRANSITION_FALLBACK_MS = 350;

    function setTransitioning($drawer) {
      $drawer.addClass('is-transitioning');

      $drawer.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
        $drawer.removeClass('is-transitioning');
      });

      setTimeout(function () {
        $drawer.removeClass('is-transitioning');
      }, TRANSITION_FALLBACK_MS);
    }

    function isOpen() {
      return $('html').hasClass('js-drawer-open') && $('#NavDrawer').hasClass('drawer--is-open');
    }

    function syncFabState(open) {
      var $fab = $('[data-mobile-drawer-toggle]').first();
      if (!$fab.length) return;

      $fab.toggleClass('is-open', !!open)
          .attr('aria-expanded', open ? 'true' : 'false')
          .attr('aria-label', open ? 'Close menu' : 'Open menu');
    }

    function openNavDrawer() {
      var $drawer = $('#NavDrawer');
      var $btn = $('.site-nav__link.site-nav__link--icon.js-drawer-open-nav').first();
      if (!$drawer.length) return;

      setTransitioning($drawer);

      requestAnimationFrame(function () {
        $('html').addClass('js-drawer-open lock-scroll');
        $drawer.addClass('drawer--is-open').attr('aria-hidden', 'false').attr('tabindex','-1');
        if ($btn.length) $btn.attr('aria-expanded', 'true');

        syncFabState(true);
        $drawer.focus();
      });
    }

    function closeNavDrawer() {
      var $drawer = $('#NavDrawer');
      var $btn = $('.site-nav__link.site-nav__link--icon.js-drawer-open-nav').first();
      if (!$drawer.length) return;

      setTransitioning($drawer);

      requestAnimationFrame(function () {
        $drawer.removeClass('drawer--is-open').attr('aria-hidden', 'true');
        $('html').removeClass('js-drawer-open lock-scroll');
        if ($btn.length) $btn.attr('aria-expanded', 'false');

        syncFabState(false);
      });
    }

    function toggleNavDrawer() {
      if (isOpen()) closeNavDrawer();
      else openNavDrawer();
    }

    // FAB toggles open/close
    $(document).on('click', '[data-mobile-drawer-toggle]', function (e) {
      e.preventDefault();
      toggleNavDrawer();
    });

    // Keep in sync when user closes via the drawer close button
    $(document).on('click', '#NavDrawer .js-drawer-close', function () {
      // allow theme handlers to run too; just sync after
      setTimeout(function () { syncFabState(false); }, 0);
    });

    // Escape closes + sync
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeNavDrawer();
    });

    // Initial sync on load
    $(function () {
      syncFabState(isOpen());
    });

  })(window.jQuery);




(function () {
  const BTN_CLASS = 'itg-swatch-scroll-btn';
  const WRAP_CLASS = 'itg-swatch-scroll-wrap';
  const SCROLL_RATIO = 0.5;

  // Match your theme breakpoint here:
  const mql = window.matchMedia('(max-width: 768px)');

  function isMobile() {
    return mql.matches;
  }

  function ensureWrapper(swatches) {
    // Wrap swatches so the button can overlay without being clipped by overflow
    const parent = swatches.parentElement;
    if (!parent) return null;

    if (parent.classList.contains(WRAP_CLASS)) return parent;

    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    parent.insertBefore(wrap, swatches);
    wrap.appendChild(swatches);

    return wrap;
  }

  function removeButton(wrap) {
    if (!wrap) return;
    const btn = wrap.querySelector('.' + BTN_CLASS);
    if (btn) btn.remove();
    // Optional: unwrap if you want (usually not necessary)
  }

  function shouldShowButton(swatches) {
    // Only show if there's actually overflow to scroll
    return swatches.scrollWidth > swatches.clientWidth + 4;
  }

  function atEnd(swatches) {
    return swatches.scrollLeft + swatches.clientWidth >= swatches.scrollWidth - 4;
  }

  function updateBtn(swatches, btn) {
    if (!shouldShowButton(swatches) || atEnd(swatches)) {
      btn.classList.add('is-hidden');
    } else {
      btn.classList.remove('is-hidden');
    }
  }

  function addButton(swatches) {
    if (!isMobile()) return;

    const wrap = ensureWrapper(swatches);
    if (!wrap) return;

    // If no overflow, no button needed
    if (!shouldShowButton(swatches)) {
      removeButton(wrap);
      return;
    }

    // Prevent duplicates
    let btn = wrap.querySelector('.' + BTN_CLASS);
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = BTN_CLASS;
      btn.setAttribute('aria-label', 'Scroll colors');

      btn.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      `;

      btn.addEventListener('click', () => {
        swatches.scrollBy({
          left: swatches.clientWidth * SCROLL_RATIO,
          behavior: 'smooth'
        });
      });

      wrap.appendChild(btn);

      // Keep button state in sync
      swatches.addEventListener('scroll', () => updateBtn(swatches, btn), { passive: true });
      window.addEventListener('resize', () => updateBtn(swatches, btn), { passive: true });
    }

    updateBtn(swatches, btn);
  }

  function init() {
    document.querySelectorAll('.c-swatches').forEach(swatches => {
      const wrap = swatches.closest('.' + WRAP_CLASS);

      if (!isMobile()) {
        // remove button on desktop
        if (wrap) removeButton(wrap);
        return;
      }

      addButton(swatches);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  mql.addEventListener('change', init);

  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.complete_the_fit_add');
  if (!btn) return;

  if (typeof gtag === 'function') {
    gtag('event', 'complete_the_fit_add_click', {
      send_to: 'G-15KX0QWWZP'
    });
    console.log('triggered and sent');
  }
});




(function () {
  function moneyFormatFromShopify(cents) {
    // If Shopify formatting is available, use it
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      // Most themes expose Shopify.money_format; fall back if missing
      var fmt = (window.theme && theme.moneyFormat) || (Shopify.money_format) || "${{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
    // Fallback: basic dollars
    return "$" + (cents / 100).toFixed(2);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getSubtotalFromDOM() {
    // Many drawer carts render a subtotal element you can scrape.
    // If your theme has a known selector for subtotal, add it here.
    // Return null to force /cart.js.
    return null;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return await res.json();
  }

  function updateWidget(root, subtotalCents) {
    const thresholdCents = parseInt(root.getAttribute("data-threshold"), 10) || 0;
    const titleTemplate = root.getAttribute("data-title-template") || "";
    const subtitle = root.getAttribute("data-subtitle") || "";

    const fill = root.querySelector("[data-free-ship-fill]");
    const titleEl = root.querySelector("[data-free-ship-title]");
    const subtitleEl = root.querySelector("[data-free-ship-subtitle]");
    const bar = root.querySelector(".CartFreeShip__bar");

    if (!thresholdCents || thresholdCents <= 0) return;

    const remaining = Math.max(0, thresholdCents - subtotalCents);
    const progress = clamp((subtotalCents / thresholdCents) * 100, 0, 100);

    // Title text
    if (remaining > 0) {
      const amount = moneyFormatFromShopify(remaining);
      const title = titleTemplate.includes("{{ amount }}")
        ? titleTemplate.replaceAll("{{ amount }}", amount)
        : titleTemplate;

      titleEl.textContent = title || `You’re ${amount} away from free shipping!`;
      if (subtitleEl) subtitleEl.textContent = subtitle;
    } else {
      titleEl.textContent = "You’ve unlocked FREE shipping!";
      if (subtitleEl) subtitleEl.textContent = "";
    }

    // Progress bar
    if (fill) fill.style.width = progress + "%";
    if (bar) bar.setAttribute("aria-valuenow", String(Math.round(progress)));
  }

  async function refreshAll() {
    const widgets = document.querySelectorAll("[data-free-ship]");
    if (!widgets.length) return;

    // Try DOM-derived subtotal first if you wire it up later
    let subtotalCents = getSubtotalFromDOM();

    if (subtotalCents == null) {
      try {
        const cart = await fetchCart();
        // Shopify cart.js: total_price includes discounts and is in cents
        // If you want pre-discount subtotal, use cart.original_total_price instead.
        subtotalCents = cart.total_price;
      } catch (e) {
        return;
      }
    }

    widgets.forEach((w) => updateWidget(w, subtotalCents));
  }

  // Initial
  document.addEventListener("DOMContentLoaded", refreshAll);

  // Refresh after common cart interactions (many themes trigger these)
  document.addEventListener("cart:updated", refreshAll);
  document.addEventListener("cart:refresh", refreshAll);

  // Catch fetch/XHR cart updates if theme doesn’t dispatch events:
  // Light-touch: refresh when drawer opens (Impulse often toggles a class)
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest('[data-drawer-open], .js-drawer-open-cart, a[href="/cart"]');
    if (openBtn) setTimeout(refreshAll, 250);
  });

  // Also refresh on any add-to-cart submit
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (form && form.action && form.action.includes("/cart/add")) {
      setTimeout(refreshAll, 600);
    }
  });
})();
